import { SxProps, Theme } from '@mui/material';

export type SearchElementSize = 'small' | 'medium';

export const getSearchElementSx = (size: SearchElementSize = 'medium'): SxProps<Theme> => {
  const isSmall = size === 'small';

  return ({ shape }) => ({
    bgcolor: 'grey.50',
    borderRadius: Number(shape.borderRadius) * 2,
    p: isSmall ? 1 : 2,
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    fontSize: isSmall ? '16px' : '18px',
    color: 'text.secondary',
    '& input::placeholder': {
      fontSize: isSmall ? '16px' : '18px',
      color: 'text.secondary',
      opacity: 1,
    },
  });
};

export const searchElementSx = getSearchElementSx('medium');
